import { render } from "./ScreenOutQuestionComponent.vue?vue&type=template&id=16461727&scoped=true"
import script from "./ScreenOutQuestionComponent.vue?vue&type=script&lang=js"
export * from "./ScreenOutQuestionComponent.vue?vue&type=script&lang=js"

import "./ScreenOutQuestionComponent.vue?vue&type=style&index=0&id=16461727&scoped=true&lang=scss"

import exportComponent from "/builds/Partout/motus/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16461727"]])

export default __exports__